<template>
    <div class="pages">
        <div class="header">
            <div class="header-title">
                <p>{{ pageTitle.cn }}</p><p>{{ pageTitle.en }}</p>
            </div>
        </div>
        <div class="container" v-show="isOk">
            <p class="hasInput">必填项</p>
            <van-form @submit="onSubmit">
                <van-cell-group inset>
                    <van-field
                        v-model="name"
                        name="name"
                        placeholder="申请人姓名"
                        :rules="[{ required: true, message: '请填写申请人姓名' }]"
                    />
                    <van-field
                        v-model="idCarNo"
                        name="idCarNo"
                        placeholder="身份证号码"
                        :rules="[{ required: true, message: '请填写身份证号码' }]"
                    />
                </van-cell-group>
                <div style="width: 100%;margin: 16px 0; display: flex;justify-content: center">
                    <van-button round block type="primary" native-type="submit" style="width: 60%;">
                        查询
                    </van-button>
                </div>
            </van-form>
        </div>
        <div class="container result" v-show="!isOk">
            <a-descriptions title="查询结果">
                <a-descriptions-item label="姓名">{{ userResult.name }}</a-descriptions-item>
                <a-descriptions-item label="身份证号">{{ userResult.idCarNo }}</a-descriptions-item>
                <a-descriptions-item label="补贴账户">{{ userResult.account }}</a-descriptions-item>
                <a-descriptions-item label="补贴金额">{{ userResult.money }}</a-descriptions-item>
                <a-descriptions-item label="数据更新时间">{{ userResult.updateTime }}</a-descriptions-item>
            </a-descriptions>
            <div style="width: 100%; text-align: center">
                <van-button round type="primary" style="width: 60%;" @click="isOk = true">返回</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, CellGroup, Button } from 'vant'
import 'vant/es/button/style'
import 'vant/es/form/style'
import 'vant/es/field/style'
import 'vant/es/cell-group/style'
import { ref } from 'vue'
import {querySubsidyObjectApi} from "../../../api/townCenter";
export default {
    name: "butie",
    setup() {
        const pageTitle = {
            cn: '补贴查询',
            en: 'Subsidy Funds Inquiry'
        }
        const name = ref('')
        const isOk = ref(true)
        const idCarNo = ref('')
        const userResult = ref({})
        const onSubmit = (values) => {
            querySubsidyObjectApi('idCarNo='+values.idCarNo+'&name='+values.name).then(res => {
                if (res) {
                    userResult.value = res
                    isOk.value = false
                }
            })
        }
        return {
            pageTitle,
            name,
            isOk,
            idCarNo,
            userResult,
            onSubmit,
        }
    },
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Button.name]: Button,
    }
}
</script>

<style scoped lang="stylus">
.pages {
    width 100%
    height 100%
    background-color #F6F7FB
    .header {
        width 100%
        height 170px
        background-image url("../../../assets/img/town_home_bg.png")
        background-repeat no-repeat
        background-size 100% 100%
        font-size 22px
        color #FFF
        display flex
        align-items center
        justify-content center
        .header-title {
            width 100%
            text-align center
        }
        .header-title p:last-child {
            font-size 12px
        }
    }
    .result {
        padding 20px !important
        background #FFF !important
    }
    .container {
        width 100%
        padding 16px 0
        background-color #F6F7FB
        .hasInput {
            font-size 14px
            color #1A1A1A
            margin-bottom 10px
            margin-left 20px
        }
        .hasInput:before {
            content '* '
            color #F05A24
        }
    }
}
</style>
